/**
 * Shared marketing constants left over from the v2 landing page (the home
 * page itself now lives in `components/marketing/home/`).
 */

export const LANDING_IMAGE_BASE = '/landing/v2/images'

export const PRODUCT_HUNT_URL = 'https://www.producthunt.com/products/brew-5'
